/** @jsxImportSource @emotion/react */
import estyled from '@signal/theme/emotion'
import Typography from '@signal/components/Typography'
import { getSpacingSelector } from '@signal/theme/selectors'

export const Wrapper = estyled.div`
  height: 50%;
`

export const LicenseWrapper = estyled.div`
  margin: ${getSpacingSelector(4)}px 0;
  max-height: 300px;
  overflow: auto;
`

export const RecordWrapper = estyled.div<{
  children?: React.ReactNode
  key?: string | number
}>``

export const RecordEntry = estyled.div``

export const InstructionTypography = estyled<typeof Typography.prototype>(
  Typography
).attrs(() => ({
  variant: 'body2'
}))`
  margin-top: ${getSpacingSelector()}px;
`

export const PackageTypography = estyled<typeof Typography.prototype>(
  Typography
).attrs(() => ({
  component: 'a',
  target: '_blank',
  variant: 'body2'
}))`
  font-weight: bold;
  color: ${props =>
    props.theme.palette.type === 'light' ? 'blue' : 'lightblue'} !important;
`

export const LicenseTypography = estyled<typeof Typography.prototype>(
  Typography
).attrs(() => ({
  component: 'a',
  target: '_blank',
  variant: 'body2'
}))`
  color: ${props =>
    props.theme.palette.type === 'light' ? 'blue' : 'lightblue'} !important;
`
